<script setup lang="ts">
import { computed } from 'vue'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { SlidersHorizontal } from 'lucide-vue-next'

const props = withDefaults(defineProps<{
  label?: string
  options: { value: string; label: string }[]
  modelValue: string
}>(), { label: 'Filter' })

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const currentLabel = computed(
  () => props.options.find((option) => option.value === props.modelValue)?.label ?? props.label,
)

const handleSelect = (value: string) => {
  const next = value === props.modelValue ? (props.options[0]?.value ?? '') : value
  emit('update:modelValue', next)
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="outline"
        size="sm"
        class="h-10 shrink-0 gap-2 rounded-[10px] border-gray-300 px-4 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
      >
        <SlidersHorizontal class="size-5" />
        {{ currentLabel }}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-56">
      <DropdownMenuItem
        v-for="option in options"
        :key="option.value"
        :class="
          modelValue === option.value
            ? 'font-semibold text-brand-500 dark:text-brand-400'
            : ''
        "
        @select="handleSelect(option.value)"
      >
        {{ option.label }}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
